/**
 * How far back the app reads history on load. Keeping these windows small is
 * what makes the Workout / Nutrition / Statistics screens open quickly on a
 * phone — older rows stay on the server and are never sent to the client.
 */

/** Workout sessions (Statistics, dashboard tiles, plan progress). */
export const WORKOUT_HISTORY_DAYS = 180;

/** Everything else: calendar, body measurements, community feed, adherence. */
export const SECONDARY_HISTORY_DAYS = 60;
